import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { listPropertyBenefitsImage } from 'config/imageUrls';
import { ListPageAnchorEnum } from '../types';

import { ContentSection, StyledBulletList, HighlightedTitle } from './styles';

export const FeaturesBenefits = () => {
  return (
    <div id={ListPageAnchorEnum.features}>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12} md={7}>
            <Typography variant="h2" mb={2}>
              Features &amp; Benefits
            </Typography>
            <Typography>Operating a successful vacation rental property has never been easier.</Typography>
            <HighlightedTitle variant="h3" mt={3}>
              Simple to use Management Dashboard
            </HighlightedTitle>
            <StyledBulletList className="width50">
              <li>Complete reservation management.</li>
              <li>House rules and policy settings.</li>
              <li>Property and market pricing insights.</li>
              <li>Upcoming calendar events.</li>
              <li>Guest communication inbox.</li>
              <li>Cleaning and Pet Fee Settings.</li>
              <li>Photo gallery tools and captions.</li>
              <li>Availability and nightly rate control.</li>
              <li>...and much more.</li>
            </StyledBulletList>
            <HighlightedTitle variant="h3" mt={3}>
              Save Time with Automation
            </HighlightedTitle>
            <StyledBulletList>
              <li>Scheduled emails to guests before arrival with check-in instructions and details.</li>
              <li>Automatically follow-up with guests for feedback and reviews after departure.</li>
              <li>Create an in-depth property guidebook that guests receive to reduce questions.</li>
            </StyledBulletList>
            <HighlightedTitle variant="h3" mt={3}>
              Accounting &amp; Taxes
            </HighlightedTitle>
            <StyledBulletList>
              <li>Similar payout rules as other hosting websites to ensure easy accounting.</li>
              <li>Collection and remittance of Federal (GST) and Provincial (MRDT, PST) taxes.</li>
              <li>Automatic tax withholding (NR4) for non-resident clients and their CRA obligations.</li>
            </StyledBulletList>
          </Grid>
          <Grid item xs={12} md={5} align="center">
            <img
              src={listPropertyBenefitsImage}
              width="100%"
              style={{ maxWidth: '485px' }}
              className="add-image-shadow"
            />
          </Grid>
        </Grid>
      </ContentSection>
    </div>
  );
};
